import React from "react";
import {IconProps} from "../../../../../icons/icon-props-interface";

const IconMegaphone: React.FC<IconProps> = ({ color = 'var(--color-primary-2-50)' }) => {
    return (
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.0625 0.937178C14.0625 0.559248 13.834 0.216475 13.4824 0.0699903C13.1309 -0.0764941 12.7295 0.0055372 12.46 0.272139L11.1826 1.55241C9.77637 2.95866 7.86914 3.74968 5.87988 3.74968H5.625H4.6875H1.875C0.84082 3.74968 0 4.5905 0 5.62468V8.43718C0 9.47136 0.84082 10.3122 1.875 10.3122V14.0622C1.875 14.5807 2.29395 14.9997 2.8125 14.9997H4.6875C5.20605 14.9997 5.625 14.5807 5.625 14.0622V10.3122H5.87988C7.86914 10.3122 9.77637 11.1032 11.1826 12.5094L12.46 13.7868C12.7295 14.0563 13.1309 14.1354 13.4824 13.9889C13.834 13.8425 14.0625 13.5026 14.0625 13.1217V8.79753C14.6074 8.53972 15 7.84538 15 7.028C15 6.21062 14.6074 5.51628 14.0625 5.25847V0.937178Z"
                fill={color}
            />
        </svg>
    );
}

export default IconMegaphone;